import { Card, Form, FormInstance, Select } from 'antd';

import { useSkillCategory } from '../../../hooks/useSkillCategory';

interface OnboardSkillsStepProps {
  form: FormInstance<any>;
  totalSteps: number;
  currentStep: number;
}

export const OnboardSkillsStep = ({ totalSteps, currentStep }: OnboardSkillsStepProps) => {
  const { data: skillCategories } = useSkillCategory();

  return (
    <Card title="Select your skills" extra={`Step ${currentStep} of ${totalSteps}`}>
      {skillCategories?.map((category) => (
        <Form.Item label={category.name} key={category.id}>
          <Select
            mode="multiple"
            allowClear
            placeholder={`Please select your ${category.name} skills`}
            style={{ width: '100%' }}>
            {category.skillTypes?.map((skill) => (
              <Select.Option key={skill.id} value={skill.id}>
                {skill.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      ))}
    </Card>
  );
};
